import React, { useEffect, useState, useContext } from "react";
import { Helmet } from "react-helmet";
import { Link} from "react-router-dom";
import nopreview from "../../assets/images/others/noauth.svg";
import { BlankPreview } from "../../components/BlankPreview.jsx";
import { Icon } from "@iconify/react";
import moment from "moment";
import { toast } from "sonner";


function UnAuth() {

  return (
    <>
      <Helmet>
        <title>Spandan - Not Authorized</title>
      </Helmet>

      <div className="main-wrappers">
        
        <div
          className="page-wrapper"
          style={{
            paddingBottom: "10px",
            paddingTop: "75px",
          }}
        >
          <div className="content">
           
            
            <BlankPreview
                      icon={nopreview}
                      title="You do not have access to this page"
                      subtitle=""
                    />
          </div>
        </div>
      </div>
    </>
  );
}

export default UnAuth;
